<!--
 * @Descripttion: 漏斗图配置
 * @Author: zenghua.wang
 * @Date: 2021-09-06 14:00:53
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-11-16 10:23:35
-->
<template>
  <el-collapse
    v-model="collapse"
    accordion
  >
    <el-collapse-item
      name="1"
      :title="component.basic"
    >
      <config-base :data="data" />
    </el-collapse-item>

    <!-- 接口设置 -->
    <api-interface
      :data="data"
      :apis="main.apiTableList"
    >
      <template v-slot:extend>
        <echart-field :data="data" />
        <echart-filter :data="data" />
      </template>
    </api-interface>

    <el-collapse-item title="漏斗图">
      <el-form-item label="显示引导线">
        <el-switch
          v-model="data.option.labelLine"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="自动排序">
        <el-switch
          v-model="data.option.sort"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="不展示零">
        <el-switch
          v-model="data.option.notCount"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>
    </el-collapse-item>

    <!-- echart公共 -->
    <echart-common :data="data" />
  </el-collapse>
</template>
<script>
import configBase from '@/dragComponents/config/common/base.vue'
import apiInterface from '@/dragComponents/config/api/index.vue'
import echartField from '@/dragComponents/config/common/field.vue'
import echartFilter from '@/dragComponents/config/common/filter.vue'

import echartCommon from './common.vue'

import {
  predefineColors,
  component,
  theme
} from '@/dragComponents/model/default.js'
export default {
  name: 'config-echart-funnel',
  components: {
    configBase,
    echartCommon,
    echartField,
    echartFilter,
    apiInterface
  },
  inject: ['main', 'category'],
  props: ['data', 'collapse'],
  data() {
    return {
      theme: theme,
      predefineColors: predefineColors,
      component: component
    }
  },
  methods: {}
}
</script>
